import { Box, Typography, useTheme, Grid, Divider, Paper } from "@mui/material";
import { tokens } from "../../theme";
import { useSelector } from "react-redux";
import { selectIsStaffUser } from "../../store/user/user.selector";

// import { useState, useEffect } from "react";

const PesquisarProdutosTable = (props) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isStaff = useSelector(selectIsStaffUser);
    const { data, prods } = props
    const sortedProds = prods

    console.log('data: ', data)



    function distributeByVerticalColumns(array, columns) {
        const rows = Math.ceil(array.length / columns);
        const result = Array.from({ length: columns }, () => []);
        array.forEach((item, index) => {
            const col = Math.floor(index / rows); // ← aqui está a mágica
            result[col].push(item);
        });
        return result;
    }



    return (
        <Box
            component={Paper}
            elevation={6}
            p={1}
            pb={0}
            sx={{
                backgroundColor: colors.pink[700],
                borderRadius: '6px'
            }}
        >
            {
                sortedProds.map((prod) => {
                    console.log('data::', data)
                    const lenProdSeller = data
                        .filter((item, index, self) =>
                            index === self.findIndex((t) => t.prod.id_produto === item.prod.id_produto && t.nome === item.nome)
                        )
                        .filter((sellerProd) => sellerProd.prod.id_produto.toString() === prod.toString())?.length;
                    const sellersForProd = data.filter((item, index, self) =>
                        index === self.findIndex((t) => t.prod.id_produto === item.prod.id_produto && t.nome === item.nome)
                    )
                        .filter((sellerProd) => sellerProd.prod.id_produto.toString() === prod.toString())

                    const columns = distributeByVerticalColumns(sellersForProd, 4);


                    return (
                        <Box key={prod} mb={2}>
                            <Typography color={colors.blueAccent[200]} fontWeight="bold" sx={{ textDecoration: 'underline' }}>
                                {prod} {isStaff && ` - (${lenProdSeller} Vendedoras)`}
                            </Typography>
                            <Grid container spacing={2}>
                                {columns.map((col, colIndex) => (
                                    <Grid item xs={12} sm={6} md={3} key={colIndex}>
                                        {col.map((seller) => (
                                            <Typography key={seller.id + prod}>
                                                {seller.nome}
                                            </Typography>
                                        ))}
                                    </Grid>
                                ))}
                            </Grid>
                            <Divider sx={{ marginTop: '10px' }} />
                        </Box>
                    )
                })
            }
        </Box>
    );
}

export default PesquisarProdutosTable;